import { render, staticRenderFns } from "./WhatsAppConversationDrawer.vue?vue&type=template&id=6b813976&scoped=true"
import script from "./WhatsAppConversationDrawer.vue?vue&type=script&lang=js"
export * from "./WhatsAppConversationDrawer.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppConversationDrawer.vue?vue&type=style&index=0&id=6b813976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b813976",
  null
  
)

export default component.exports